module.exports = __webpack_public_path__ + "img/bullet_3.59e9a983.svg";